<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card title="KEEP IN TOUCH WITH US" pace="6"> </base-info-card>

      <base-business-contact dense />
    </div>
  </v-theme-provider>
</template>

<script>
export default {
  name: "BaseBusinessInfo",

  props: { dark: Boolean },

  data: () => ({
    business: [
      {
        icon: "mdi-map-marker-outline",
        title: "Address",
        text: "Kenwyn Accounting and IT Services Pte. Ltd . <br>No 28,Riverside Road ,<br> Singapore 739085",
      },
      {
        icon: "mdi-cellphone",
        title: "Phone",
        text: "+65-97223997",
      },
      {
        icon: "mdi-email",
        title: "Email",
        text: "info@kenwynaccounting.com",
      },
    ],
  }),
};
</script>
